export default __webpack_public_path__ + "static/media/ThumbsDown_Small_Outline.d1a52025.svg";